<template>
    <transition name="fade">
        <div class="py-5 px-0 text-center">
            <img src="@/assets/loading.gif" width="100" alt="Cargando...">
            <p class="text-muted">Espere un momento, por favor...</p>
        </div>
    </transition>   
</template>